import { BarChartBase } from './BarChartBase'
import type { BarChartBaseProps, BarChartSeries } from './BarChartBase'

import type { JSX } from 'react'

export type { BarChartSeries }

export type StackedBarChartProps = Omit<BarChartBaseProps, 'stacked'>

/**
 * Stacked bar chart — every series is stacked into one bar per period, so the
 * bar's height is the period total and each segment its share. Standalone: hand
 * it `series` (label + colour + day-resolution data) and it renders. For side
 * by side columns instead, use `BarChart`.
 */
export function StackedBarChart(props: StackedBarChartProps): JSX.Element {
  return <BarChartBase {...props} stacked />
}
